import { Component, input, OnInit, Signal } from '@angular/core';
import { EditableTextComponent } from '../../base/text/editable-text/editable-text.component';
import { Result } from '../../../state-management/model/interfaces/state.model';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { EditableButtonComponent } from "../../base/button/editable-button/editable-button.component";

@Component({
  selector: 'app-c-highlight-box',
  imports: [EditableTextComponent, EditableButtonComponent],
  templateUrl: './c-highlight-box.component.html',
  styleUrl: './c-highlight-box.component.scss'
})
export class CHighlightBoxComponent implements OnInit {
  readonly componentId = input<string>('');

  public highlightTextId!: Signal<Result<string, string>>;
  public buttonId!: Signal<Result<string, string>>;

  constructor(private stateService: WebsiteStateService) { }

  ngOnInit(): void {
    this.highlightTextId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'highlight-text');
    this.buttonId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'button');
  }
}